import { ShipType, SHIP_TYPE_COUNT } from './ShipTypes';

export interface FleetConfig {
  composition: number[];
  formationSpacing: number;
  indicatorColor: [number, number, number];
  indicatorSize: number;
  indicatorZoomThreshold: number;
}

export function defaultFleetConfig(): FleetConfig {
  const comp = new Array<number>(SHIP_TYPE_COUNT).fill(0);
  comp[ShipType.Scout] = 3;
  comp[ShipType.Fighter] = 1;
  return {
    composition: comp,
    formationSpacing: 0.4,
    indicatorColor: [0.3, 0.85, 1.0],
    indicatorSize: 0.5,
    indicatorZoomThreshold: 12,
  };
}
